import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-validete-password',
  templateUrl: './validete-password.component.html',
  styleUrls: ['./validete-password.component.scss']
})
export class ValidetePasswordComponent implements OnChanges {
  validateValue = {
    quantidadeCaracters: false,
    minCaracters: false,
    maxCaracters: false,
    numberCaracters: false,
  };

  @Output() passwordValidate: EventEmitter<boolean> = new EventEmitter();

  @Input() valuePassword: string;

  ngOnChanges(): void {
    this.validatorRegex(this.valuePassword);
  }

  validatorRegex(value: string) {
    const quantidadeCaracters = /.{8,}/;
    const minCaracters = /[a-z]/;
    const maxCaracters = /[A-Z]/;
    const numberCaracters = /\d/;

    if (quantidadeCaracters.test(value)) {
      this.validateValue.quantidadeCaracters = true;
    } else {
      this.validateValue.quantidadeCaracters = false;
    }

    if (minCaracters.test(value)) {
      this.validateValue.minCaracters = true;
    } else {
      this.validateValue.minCaracters = false;
    }

    if (maxCaracters.test(value)) {
      this.validateValue.maxCaracters = true;
    } else {
      this.validateValue.maxCaracters = false;
    }

    if (numberCaracters.test(value)) {
      this.validateValue.numberCaracters = true;
    } else {
      this.validateValue.numberCaracters = false;
    }

    if (
      this.validateValue.quantidadeCaracters &&
      this.validateValue.minCaracters &&
      this.validateValue.maxCaracters &&
      this.validateValue.numberCaracters
    )
      this.passwordValidate.emit(true);
  }
}
